import { createContext } from 'react';

import type { RuleAction } from '../types';

export const CardActionContext = createContext<RuleAction[]>([]);
